import React, { useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { AppContext } from '../window';
import { useTranslation } from '../i18n';
import TermsConditionsModal from '../about/TermsConditionsModal';
import PrivacyPolicyModal from '../about/PrivacyPolicyModal';
import { useModal } from '../hooks/useModal';

interface DisclaimerModalProps {
  show: boolean;
  onAccept: () => void;
}

const DisclaimerModal: React.FC<DisclaimerModalProps> = ({ show, onAccept }) => {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const termsModal = useModal();
  const privacyModal = useModal();

  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    termsModal.open();
  };

  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    privacyModal.open();
  };

  return (
    <>
    <Modal 
      show={show} 
      onHide={() => {}} // Prevent closing by clicking outside
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      className="disclaimer-modal"
    >
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="w-100 text-center">
          <h4 className="mb-0 fw-bold">
            {t('modal.age_disclaimer_title')}
          </h4>
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label={t('general.close')}
          onClick={() => window.location.href = 'https://google.com'}
        />
      </Modal.Header>

      <Modal.Body className="px-4 py-3">
        <div className="text-center">
          <div className="mb-4">
            <div className="display-1 mb-3">🔞</div>
            <h5 className="fw-semibold mb-3">
              {t('modal.age_disclaimer_subtitle')}
            </h5>
          </div>

          <div className="text-start bg-body-tertiary rounded p-3 mb-3">
            <p className="mb-2">
              <strong>{t('modal.age_disclaimer_text')}</strong>
            </p>
            <ul className="mb-0">
              <li>{t('modal.age_disclaimer_18plus')}</li>
              <li>{t('modal.age_disclaimer_cookies')}</li>
              <li>
                {t('modal.age_disclaimer_terms')} <a href="#" onClick={handleTermsClick} className="text-decoration-underline">{t('modal.terms_and_conditions')}</a>, <a href="#" onClick={handlePrivacyClick} className="text-decoration-underline">{t('modal.privacy_policy')}</a>
              </li>
            </ul>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0 pb-4 px-4">
        <Button 
          variant="primary" 
          size="lg"
          className="w-100 py-3"
          onClick={onAccept}
        >
          <strong>{t('modal.age_disclaimer_accept')}</strong>
        </Button>
      </Modal.Footer>
    </Modal>

    <TermsConditionsModal 
      show={termsModal.isOpen} 
      onHide={termsModal.close} 
    />

    <PrivacyPolicyModal 
      show={privacyModal.isOpen} 
      onHide={privacyModal.close} 
    />
    </>
  );
};

export default DisclaimerModal;